import { createTheme, responsiveFontSizes } from '@material-ui/core/styles';

export const portalTheme = responsiveFontSizes(
    createTheme({
        // Palette
        palette: {
            primary: {
                main: '#00629B',
            },
            secondary: {
                contrastText: '#fff',
                main: '#243A62',
            },
        },

        // Typography
        typography: {
            fontFamily: 'Open Sans',
            h1: { fontSize: '4rem', lineHeight: '4.375' },
            h2: { fontSize: '3rem', lineHeight: '3.375' },
            h3: { fontSize: '2.5rem', lineHeight: '3' },
            h4: { fontSize: '2.25rem', lineHeight: '2.625' },
            h5: { fontSize: '1.75rem', lineHeight: '2.125' },
            h6: { fontSize: '1.25rem', lineHeight: '1.625' },
        },
        overrides: {
            MuiButton: {
                root: {
                    textTransform: 'none',
                },
            },
            MuiAccordion: {
                root: {
                    '&.bordered-accordion': {
                        borderRadius: '5px!important',
                        border: '1px solid #D1D1D1',
                        boxShadow: 'none',
                        transition: 'all 0.2s ease',
                        '&:before': {
                            display: 'none',
                        },
                        '& .MuiAccordionSummary-root': {
                            padding: '0 10px',
                            backgroundColor: '#F1F1F1',
                            '&.Mui-expanded': { minHeight: 'auto' },
                        },
                        '& .MuiAccordionSummary-content': {
                            margin: '0px',
                            '&.Mui-expanded': { margin: '0px' },
                        },
                        '&.Mui-expanded': {
                            margin: '10px 0 0',
                            backgroundColor: '#fff',
                            '&:first-of-type': {
                                margin: 0,
                            },
                        },
                        '& .MuiAccordionDetails-root': {
                            padding: 10,
                            borderTop: '1px solid #D1D1D1',
                        },
                    },
                },
            },
        },
    }),
);
